import FilePreview2 from "components/FilePreview/FilePreview2";
import CommonTable from "components/ViewTable/ViewTable";
import React from "react";
import { Badge, Card, Col, Container, Row, Table } from "react-bootstrap";

interface BranchDetailsViewProps {
  data?: any;
}

const BranchDetails: React.FC<BranchDetailsViewProps> = ({
  data,
}) => {


const branchColumns = [
  {
    label: "Sr. No.",
    align: "center" as const,
    render: (_row: any, index?: number) => (
      <div style={{ minWidth: 100 }}>{(index ?? 0) + 1}</div>
    ),
  },
  {
    label: "Branch Name",
    render: (branch: any) => (
      <div style={{ minWidth: 100 }}>
        {branch.branch_name || "—"}
        {branch.is_primary && (
          <Badge bg="primary" className="ms-2">
            Primary
          </Badge>
        )}
      </div>
    ),
  },
  {
    label: "Email",
    render: (branch: any) => (
      <div style={{ minWidth: 100 }}>
        {branch.branch_email || "—"}
      </div>
    ),
  },
  {
    label: "Phone No.",
    render: (branch: any) => (
      <div style={{ minWidth: 100 }}>
        {branch.branch_phone_number || "—"}
      </div>
    ),
  },
  {
    label: "GST No.",
    render: (branch: any) => (
      <div style={{ minWidth: 100 }}>
        {branch.gst_document_name || "—"}
      </div>
    ),
  },
  {
    label: "GST Document",
    render: (branch: any) => (
      <div style={{ minWidth: 100 }}>
        <FilePreview2 file={branch.gst_document_url} />
      </div>
    ),
  },
  {
    label: "Contact Person Name",
    render: (branch: any) => (
      <div style={{ minWidth: 150 }}>
        {branch.contact_name || "—"}
      </div>
    ),
  },
  {
    label: "Email",
    render: (branch: any) => (
      <div style={{ minWidth: 100 }}>
        {branch.contact_email || "—"}
      </div>
    ),
  },
  {
    label: "Phone",
    render: (branch: any) => (
      <div style={{ minWidth: 100 }}>
        {branch.contact_phone_number || "—"}
      </div>
    ),
  },
  {
    label: "Address",
    render: (branch: any) => (
      <div
        style={{
          minWidth: 200,
          wordBreak: "break-word",
          whiteSpace: "normal",
        }}
      >
        {branch.address ? (
          <>
            {branch.address}
            {branch.city && `, ${branch.city}`}
            {branch.state && `, ${branch.state}`}
            {branch.country && `, ${branch.country}`}
            {branch.pincode && ` - ${branch.pincode}`}
          </>
        ) : (
          "—"
        )}
      </div>
    ),
  },
];

  return (

      <Card>
        <Card.Body>
          {/* Branches Table */}
          <Row>
            <Col md={12}>
              <h5 className="mb-3">Branch Details</h5>
             <CommonTable
                columns={branchColumns}
                data={data.branches}
                tableClassName="common-table"
                onRowClick={(row) => console.log("Clicked:", row)}
              />
            </Col>
          </Row>
        </Card.Body>
      </Card>

  );
};

export default BranchDetails;
